module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-6-3bc0a94c1212c0cf01bff480e3547f93.jpg";